import { memo, useCallback } from 'react'

import { setOpenModal } from 'state/app/reducer'
import { selectShowModal } from 'state/app/selectors'
import { useAppDispatch, useAppSelector } from 'state/hooks'

import TransferSmartMarginModal from '../Trade/ManageSmartMarginModal'

import AddDelegateModal from './AddDelegateModal'
import { DelegationTab } from './DelegationTradingTab'
import RemoveDelegateModal from './RemoveDelegateModal'
import RenameAddressModal from './RenameAddressModal'

const DelegationManageModal = memo(() => {
	const dispatch = useAppDispatch()
	const openModal = useAppSelector(selectShowModal)

	const onDismiss = useCallback(() => {
		dispatch(setOpenModal(null))
	}, [dispatch])

	const returnToDelegatesTab = useCallback(() => {
		dispatch(setOpenModal('manage_delegates'))
	}, [dispatch])

	const returnToSubAccoutnsTab = useCallback(() => {
		dispatch(setOpenModal('manage_subaccounts'))
	}, [dispatch])

	return (
		<>
			{openModal === 'manage_delegates' && (
				<TransferSmartMarginModal onDismiss={onDismiss} defaultTab={DelegationTab.Delegations} />
			)}
			{openModal === 'manage_subaccounts' && (
				<TransferSmartMarginModal onDismiss={onDismiss} defaultTab={DelegationTab.SubAccounts} />
			)}
			{openModal === 'add_delegate' && <AddDelegateModal onDismiss={returnToDelegatesTab} />}
			{openModal === 'remove_delegate' && <RemoveDelegateModal onDismiss={returnToDelegatesTab} />}
			{openModal === 'rename_delegate' && (
				<RenameAddressModal onDismiss={returnToDelegatesTab} type={'delegate'} />
			)}
			{openModal === 'rename_subaccount' && (
				<RenameAddressModal onDismiss={returnToSubAccoutnsTab} type={'subaccount'} />
			)}
		</>
	)
})

export default DelegationManageModal
